import { TypeNatureMarcheDivers } from "./TypeNatureMarcheDivers";
import { TypeObjCPV } from "./TypeObjCPV";

export class TypeDescNatureMarcheDivers {

 	public natureMarche: TypeNatureMarcheDivers;

	public cpv: TypeObjCPV;

	constructor() {
		this.natureMarche = new TypeNatureMarcheDivers();
		this.cpv = new TypeObjCPV();
	}
}
